import React, { useState, Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthModal from "./components/AuthModal";

// Lazy load all pages for code splitting
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Events = lazy(() => import("./pages/Events"));
const Resources = lazy(() => import("./pages/Resources"));
const Contact = lazy(() => import("./pages/Contact"));
const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));
const SpaceInvaders404 = lazy(() => import("./pages/404"));

// Loading component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Loading...
  </div>
);

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <Router>
      {/* 🔒 Modal Login Component */}
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />

      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route
            path="/"
            element={<Home setShowAuthModal={setShowAuthModal} />}
          />
          <Route
            path="/about"
            element={<About setShowAuthModal={setShowAuthModal} />}
          />
          <Route
            path="/events"
            element={<Events setShowAuthModal={setShowAuthModal} />}
          />
          <Route
            path="/resources"
            element={<Resources setShowAuthModal={setShowAuthModal} />}
          />
          <Route
            path="/contact"
            element={<Contact setShowAuthModal={setShowAuthModal} />}
          />
          <Route
            path="/UnderConstruction"
            element={<UnderConstruction setShowAuthModal={setShowAuthModal} />}
          />
          <Route path="*" element={<SpaceInvaders404 />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
